<template>
    <v-container fluid>
      <v-layout row v-if="user.managerOrHigher" class="mb-2">
        <v-flex>
          <router-link :to="{ name: 'managedTodoLists' }">
            <v-btn color="primary">
              Go to managed tasks
            </v-btn>
          </router-link>
        </v-flex>
      </v-layout>

      <v-layout row align-center>
        <h1 class="display">My Tasks</h1>
        <v-flex class="text-xs-right">
          <NewTaskDialog />
        </v-flex>
      </v-layout>

      <v-layout row v-if="overdue.length > 0" class="mb-4">
        <v-flex grow xs12>
          <v-alert icon="timer" type="warning" :value="true">
            <h2 class="title">Overdue</h2>
          </v-alert>

          <v-data-iterator
            :items="overdue"
            column
            content-tag="v-layout"
            :rows-per-page-items="[-1]"
            hide-actions
          >
            <template v-slot:item="props">
              <v-flex xs12 class="pa-1">
                <TodoItem :item="props.item" />
              </v-flex>
            </template>
          </v-data-iterator>
        </v-flex>
      </v-layout>

      <v-layout column>
        <v-tabs
        grow
        icons-and-text
        v-model="tab"
        dark
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab>
            Upcoming
            <v-icon>inbox</v-icon>
          </v-tab>

          <v-tab>
            Done Recently
            <v-icon>check_circle</v-icon>
          </v-tab>
        </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat>
              <v-card-text>
              <v-progress-linear v-if="tasksLoading" indeterminate />
              <v-data-iterator
                :items="upcomingItems"
                column
                content-tag="v-layout"
                :rows-per-page-items="[-1]"
                hide-actions
              >
                <template v-slot:item="props">
                  <v-flex xs12 class="pa-1">
                    <TodoItem :item="props.item" />
                  </v-flex>
                </template>
              </v-data-iterator>
              </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
              <v-card-text>
              <v-data-iterator
                :items="doneItems"
                column
                content-tag="v-layout"
                :rows-per-page-items="[10]"
              >
                <template v-slot:item="props">
                  <v-flex xs12 class="pa-1">
                    <TodoItem :item="props.item" />
                  </v-flex>
                </template>
              </v-data-iterator>
              </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

      </v-layout>
    </v-container>

</template>

<script>

import { mapState, mapGetters } from 'vuex'
import TodoItem from './todo-item.vue'
import NewTaskDialog from './new-todo-item-dialog.vue'

export default {
  components: {
    TodoItem,
    NewTaskDialog
  },
  data() {
    return {
      tab: 0,
      pendingID: null,
      tasksLoading: false,
      pagination: {
        // sortBy: 'due_on',
        // descending: true,
        rowsPerPage: 10,
      },
      headers: [
        {
        },
        {
          text: 'Due',
          value: 'due_on',
        },
        {
          text: 'Task',
          value: 'description'
        }
      ],
    }
  },
  computed: {
    ...mapState('todos', [
      'items'
    ]),
    ...mapState('userAuth', [
      'user'
    ]),
    undoneItems() {
      return this.items.filter((t) => {
        if (!t.done) {
          return t
        }
      })
    },
    doneItems() {
      const items = this.items.filter((t) => {
        if (t.done) {
          return t
        }
      })

      const sorted = _.orderBy(
        items,
        [ 'done_on' ],
        [ 'desc' ]
      )
      return sorted
    },

    overdue() {
      return this.items.filter((t) => {
        const now = this.$moment()
        if (!t.done && t.due_on && this.$moment(t.due_on).isBefore(now)) {
          return t
        }
      })
    },
    upcomingItems() {
      const items = this.items.filter((t) => {
        const now = this.$moment()
        if (!t.done && !this.overdue.map(t => t.id).includes(t.id)) {
          return t
        }
      })
      // Sort by due first, then created_at
      const sorted = _.orderBy(
        items,
        [ 'due_on', 'created_at' ],
        [ 'asc', 'asc' ]
      )
      return sorted
    }
  },
  created() {
    this.tasksLoading = true
    this.$store.dispatch('todos/getMine')
    .then((t) => {
      this.tasksLoading = false
    })
  },
  methods: {
    itemPending(itemID) {
      if (this.pendingID === itemID) {
        return true
      }
      return false
    },
  }
}
</script>

